// extracted by mini-css-extract-plugin
module.exports =  {"popover":"ghlHl5vh8kpr3TJJB8Xv","info":"DslV2x7KqtXq59M1hfV7"};